import { Directive, Input, Output, ElementRef, EventEmitter, Renderer2, NgZone, ChangeDetectorRef, AfterContentInit, OnInit, OnDestroy } from '@angular/core';
import { AnimationEvent } from './animations.interface';
export class CollapseAnimationDirective implements OnInit, AfterContentInit, OnDestroy {
private firstStart = true;
private isCollapsed: boolean;
private lastIsCollapsed: boolean;
private offsetHeight: number;
private event: AnimationEvent;
private transitioning: boolean;
private listener: Function;
public collapseAnimationDuration = 350;
public collapseAnimationTiming: string;
/**
 * @param {?} value
 * @return {?}
 */
public set _isCollapsed(value: boolean) {
    this.lastIsCollapsed = this.isCollapsed;
    this.isCollapsed = value;
    if(!this.firstStart) {
      this.emit('start');
      if(value) {
        this.collapse();
      } else if(value === false) {
        this.unCollapse();
      }
    }
  }
public startEventEmitter = new EventEmitter();
public doneEventEmitter = new EventEmitter();
/**
 * \@method constructor
 * @param {?} elementRef
 * @param {?} ngZone
 * @param {?} renderer2
 */
constructor(
private elementRef: ElementRef,
private ngZone: NgZone,
private renderer2: Renderer2
  ) {}
/**
 * \@method ngOnInit
 * @return {?}
 */
ngOnInit() {
    if(this.collapseAnimationDuration && this.collapseAnimationDuration !== 350) {
      this.renderer2.setStyle(this.elementRef.nativeElement, 'transition-duration', `${this.collapseAnimationDuration}ms`);
    }
    if(this.collapseAnimationTiming) {
      this.renderer2.setStyle(this.elementRef.nativeElement, 'transition-timing-function', this.collapseAnimationTiming);
    }
  }
/**
 * \@method ngAfterContentInit
 * @return {?}
 */
ngAfterContentInit() {
    this.emit('start');
    if(this.isCollapsed) {
      this.renderer2.setStyle(this.elementRef.nativeElement, 'display', 'none');
      this.renderer2.addClass(this.elementRef.nativeElement, 'collapsing');
    }
    this.emit('done');
    this.firstStart = false;

    this.subscriptions();
  }
/**
 * [ngOnDestroy description]
 * \@method ngOnDestroy
 * @return {?}
 */
ngOnDestroy() {
    if(this.listener) {
      this.listener();
    }
  }
/**
 * [subscriptions description]
 * \@method subscriptions
 * @return {?}
 */
private subscriptions(): void {
    this.ngZone.runOutsideAngular(() => {
      this.listener = this.renderer2.listen(this.elementRef.nativeElement, 'transitionend', () => {
        if(!this.isCollapsed) {
          this.renderer2.removeClass(this.elementRef.nativeElement, 'un-collapse');
          this.renderer2.removeClass(this.elementRef.nativeElement, 'collapsing');
        } else {
          this.renderer2.setStyle(this.elementRef.nativeElement, 'display', 'none');
        }
        requestAnimationFrame(() => {
          this.renderer2.removeStyle(this.elementRef.nativeElement, 'height');
          this.emit('done');
          this.transitioning = false;
        });
      });
    });
  }
/**
 * [unCollapse description]
 * \@method unCollapse
 * @return {?}
 */
private unCollapse(): void {
    this.transitioning = true;
    this.renderer2.addClass(this.elementRef.nativeElement, 'un-collapse');
    this.renderer2.removeStyle(this.elementRef.nativeElement, 'display');
    this.renderer2.setStyle(this.elementRef.nativeElement, 'height', `${this.elementRef.nativeElement.scrollHeight}px`);
  }
/**
 * [collapse description]
 * \@method collapse
 * @return {?}
 */
private collapse(): void {
    requestAnimationFrame(() => {
      if(!this.transitioning) {
        this.renderer2.setStyle(this.elementRef.nativeElement, 'height', `${this.elementRef.nativeElement.offsetHeight}px`);
        this.renderer2.addClass(this.elementRef.nativeElement, 'collapsing');
      }
      this.transitioning = true;
      requestAnimationFrame(() => {
        this.renderer2.setStyle(this.elementRef.nativeElement, 'height', `0px`);
      });
    });
  }
/**
 * @param {?} phaseName
 * @return {?}
 */
private emit(phaseName: string): void {
    let /** @type {?} */ event: AnimationEvent = {
      element: this.elementRef.nativeElement,
      fromState: this.lastIsCollapsed === undefined ? 'void' : this.lastIsCollapsed ? '1': '0',
      phaseName: phaseName,
      toState: this.isCollapsed === undefined ? 'void' : this.isCollapsed ? '1': '0',
      totalTime: this.collapseAnimationDuration,
      triggerName: 'collapseAnimation'
    }

    if(phaseName === 'done') {
      this.doneEventEmitter.emit(event);
    } else if(phaseName === 'start') {
      this.startEventEmitter.emit(event);
    }
  }
static decorators: DecoratorInvocation[] = [
{ type: Directive, args: [{
  selector: '[collapseAnimation]'
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ElementRef, },
{type: NgZone, },
{type: Renderer2, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'collapseAnimationDuration': [{ type: Input },],
'collapseAnimationTiming': [{ type: Input },],
'_isCollapsed': [{ type: Input, args: ['collapseAnimation', ] },],
'startEventEmitter': [{ type: Output, args: ['collapseAnimation.start', ] },],
'doneEventEmitter': [{ type: Output, args: ['collapseAnimation.done', ] },],
};
}

function CollapseAnimationDirective_tsickle_Closure_declarations() {
/** @type {?} */
CollapseAnimationDirective.decorators;
/**
 * @nocollapse
 * @type {?}
 */
CollapseAnimationDirective.ctorParameters;
/** @type {?} */
CollapseAnimationDirective.propDecorators;
/** @type {?} */
CollapseAnimationDirective.prototype.firstStart;
/** @type {?} */
CollapseAnimationDirective.prototype.isCollapsed;
/** @type {?} */
CollapseAnimationDirective.prototype.lastIsCollapsed;
/** @type {?} */
CollapseAnimationDirective.prototype.offsetHeight;
/** @type {?} */
CollapseAnimationDirective.prototype.event;
/** @type {?} */
CollapseAnimationDirective.prototype.transitioning;
/** @type {?} */
CollapseAnimationDirective.prototype.listener;
/** @type {?} */
CollapseAnimationDirective.prototype.collapseAnimationDuration;
/** @type {?} */
CollapseAnimationDirective.prototype.collapseAnimationTiming;
/** @type {?} */
CollapseAnimationDirective.prototype.startEventEmitter;
/** @type {?} */
CollapseAnimationDirective.prototype.doneEventEmitter;
/** @type {?} */
CollapseAnimationDirective.prototype.elementRef;
/** @type {?} */
CollapseAnimationDirective.prototype.ngZone;
/** @type {?} */
CollapseAnimationDirective.prototype.renderer2;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
